import {
  GET_TOGGLE_RIGHT_SIDE_BAR,
  SET_TOGGLE_RIGHT_SIDE_BAR,
} from "./actionType";

export const getToggleRightSideBar = () => {
  return {
    type: GET_TOGGLE_RIGHT_SIDE_BAR,
  };
};

export const setToggleRightSideBar = (toggleRightSideBar) => {
  return {
    type: SET_TOGGLE_RIGHT_SIDE_BAR,
    payload: toggleRightSideBar,
  };
};
